import { useRef, useState } from "react";
import { Fragment } from "react";
import { useEffect } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import ConfirmationModal from "../../../components/Common/ConfirmationModal/ConfirmationModal";
import ContentLoader from "../../../components/Common/ContentLoader/ContentLoader";
import NoDataFound from "../../../components/Common/NoDataFound/NoDataFound";
import FabButton from "../../../components/FabButton/FabButton";
import CampaignCard from "../Components/CampaignCard";
import deleteCampaign from "../Controller/deleteCampaign";
import { getCampaigns } from "../Controller/getCampaign";
import "./MarketingListing.css";
import ContentCopyRoundedIcon from "@mui/icons-material/ContentCopyRounded";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";

const MarketingListing = () => {
  //Check that is it mobile screen
  const [isMobile, setIsMobile] = useState(false);
  const [Filter, setFilter] = useState("*");
  const [hasMore, setHasMore] = useState(true);
  const [marketing, setMarketing] = useState([]);
  const [searchInput, setSearchInput] = useState("");

  const [RequestingMarketing, setRequestingMarketing] = useState(true);
  const LastSnapshot = useRef("*");
  const [Refresh, setRefresh] = useState(true);

  const navigate = useNavigate();
  const handleOpen = () => {
    navigate(`/user/marketing/campaign/`);
  };

  // Delete Start
  const [DeleteDialog, setDeleteDialog] = useState(false);
  const [DeleteCampaignId, setDeleteCampaignId] = useState("");
  const handleOpenDeleteDialog = (id) => {
    setDeleteCampaignId(id);
    setDeleteDialog(true);
  };
  const handleCloseDeleteDialog = async (del) => {
    setDeleteDialog(false);
    if (del === true) {
      await deleteCampaign(DeleteCampaignId);
      handleRefresh();
      fetchMarketing(false);
      setRequestingMarketing(true);
      setDeleteDialog(false);
    }
  };
  // Delete End

  const fetchMarketing = async (bottomFetching = true) => {
    const campaignArr = await getCampaigns(Filter, LastSnapshot.current, 2);
    if (campaignArr.campaigns.length < 2) setHasMore(false);
    LastSnapshot.current =
      campaignArr.campaignSnapshot.docs[
        campaignArr.campaignSnapshot.docs.length - 1
      ];
    if (bottomFetching) setMarketing([...marketing, ...campaignArr.campaigns]);
    else setMarketing([...campaignArr.campaigns]);
    setRequestingMarketing(false);
  };

  const handleRefresh = () => {
    LastSnapshot.current = "*";
    setMarketing([]);
    setRefresh(!Refresh);
  };

  useEffect(() => {
    handleRefresh();
    fetchMarketing(false);
    setRequestingMarketing(true);
  }, [Filter]);

  useEffect(() => handleRefresh(), []);
  const setWindowDimensions = () => {
    if (window.innerWidth < 768) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", setWindowDimensions);
    setWindowDimensions();
    return () => {
      window.removeEventListener("resize", setWindowDimensions);
    };
  }, []);
  return (
    <Fragment>
      {isMobile && (
        <FabButton
          onClick={() => {
            handleOpen("add", "");
          }}
        />
      )}
      <div className="global-body-container marketing-listing">
        {isMobile ? (
          <div>
            <div class="custom-heading">Marketing</div>
            <div className="marketing-header-bar">
              <div className="search-bar">
                <div className="input-group">
                  <input
                    type="search"
                    className="marketing-search-input"
                    placeholder="Enter name or mobile number"
                  />
                  <svg
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                    className="search-icon d-none d-xl-block"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19.1592 16.0701L15.7962 12.7027C16.3057 11.5803 16.6115 10.4578 16.6115 9.2333C16.6115 6.98843 15.7962 4.94761 14.1656 3.417C10.9045 0.15169 5.70701 0.15169 2.44586 3.417C-0.815288 6.6823 -0.815288 11.8864 2.44586 15.1517C3.97452 16.6823 6.11465 17.6007 8.2548 17.6007C9.4777 17.6007 10.7006 17.2945 11.7197 16.7843L15.0828 20.1517C15.5924 20.6619 16.4076 20.968 17.121 20.968C17.8344 20.968 18.5478 20.6619 19.1592 20.1517C20.2803 18.9272 20.2803 17.0905 19.1592 16.0701ZM3.87261 13.519C1.42675 11.0701 1.42675 7.09047 3.87261 4.74353C5.09554 3.51904 6.6242 2.90679 8.2548 2.90679C9.8854 2.90679 11.414 3.51904 12.6369 4.74353C13.8599 5.96802 14.4713 7.49863 14.4713 9.1313C14.4713 10.7639 13.8599 12.3966 12.6369 13.519C11.414 14.6415 9.8854 15.3558 8.2548 15.3558C6.6242 15.3558 4.99363 14.7435 3.87261 13.519Z"
                      fill="#929292"
                    />
                  </svg>
                </div>
              </div>
              {!isMobile && (
                <button
                  className="add-marketing-button"
                  onClick={() => {
                    handleOpen("add", "");
                  }}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 17V7"
                      stroke="white"
                      stroke-width="3"
                      stroke-linecap="round"
                    />
                    <path
                      d="M7 12H17"
                      stroke="white"
                      stroke-width="3"
                      stroke-linecap="round"
                    />
                  </svg>{" "}
                  Create Campaign
                </button>
              )}
            </div>

            <div className="campaign-tab-container">
              <button
                onClick={() => {
                  setFilter("*");
                }}
                className={`campaign-filter-button ${
                  Filter === "*" ? " campaign-filter-button-active" : ""
                }`}
              >
                All
              </button>
              <button
                onClick={() => {
                  setFilter("WhatsApp");
                }}
                className={`campaign-filter-button ${
                  Filter === "WhatsApp" ? " campaign-filter-button-active" : ""
                }`}
              >
                WhatsApp
              </button>
              <button
                onClick={() => {
                  setFilter("Email");
                }}
                className={`campaign-filter-button ${
                  Filter === "Email" ? " campaign-filter-button-active" : ""
                }`}
              >
                Email
              </button>
            </div>
          </div>
        ) : (
          <>
            <h3 className="custom-heading">Marketing</h3>
            <div className="marketing-header-bar " id="flex-none">
              <div className="links-style ">
                <a
                  href="#"
                  className={`link-tab ${Filter === "*" ? "active-tab" : ""}`}
                  onClick={() => {
                    setFilter("*");
                  }}
                >
                  All
                </a>
                <a
                  href="#"
                  className={`link-tab ${
                    Filter === "WhatsApp" ? "active-tab" : ""
                  }`}
                  onClick={() => {
                    setFilter("WhatsApp");
                  }}
                >
                  WhatsApp
                </a>
                <a
                  href="#"
                  className={`link-tab ${
                    Filter === "Email" ? "active-tab" : ""
                  }`}
                  onClick={() => {
                    setFilter("Email");
                  }}
                >
                  Email
                </a>
              </div>

              <div className="search-bar ">
                <div className="input-group">
                  <input
                    type="search"
                    className="marketing-search-input"
                    placeholder="Enter Campaign Title"
                    onChange={(e) => {
                      setSearchInput(e.target.value);
                    }}
                  />
                  <svg
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                    className="search-icon d-none d-xl-block"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19.1592 16.0701L15.7962 12.7027C16.3057 11.5803 16.6115 10.4578 16.6115 9.2333C16.6115 6.98843 15.7962 4.94761 14.1656 3.417C10.9045 0.15169 5.70701 0.15169 2.44586 3.417C-0.815288 6.6823 -0.815288 11.8864 2.44586 15.1517C3.97452 16.6823 6.11465 17.6007 8.2548 17.6007C9.4777 17.6007 10.7006 17.2945 11.7197 16.7843L15.0828 20.1517C15.5924 20.6619 16.4076 20.968 17.121 20.968C17.8344 20.968 18.5478 20.6619 19.1592 20.1517C20.2803 18.9272 20.2803 17.0905 19.1592 16.0701ZM3.87261 13.519C1.42675 11.0701 1.42675 7.09047 3.87261 4.74353C5.09554 3.51904 6.6242 2.90679 8.2548 2.90679C9.8854 2.90679 11.414 3.51904 12.6369 4.74353C13.8599 5.96802 14.4713 7.49863 14.4713 9.1313C14.4713 10.7639 13.8599 12.3966 12.6369 13.519C11.414 14.6415 9.8854 15.3558 8.2548 15.3558C6.6242 15.3558 4.99363 14.7435 3.87261 13.519Z"
                      fill="#929292"
                    />
                  </svg>
                </div>
              </div>
              <button className="add-marketing-button" onClick={handleOpen}>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 17V7"
                    stroke="white"
                    stroke-width="3"
                    stroke-linecap="round"
                  />
                  <path
                    d="M7 12H17"
                    stroke="white"
                    stroke-width="3"
                    stroke-linecap="round"
                  />
                </svg>
                Create Campaign
              </button>
            </div>
          </>
        )}

        <div className="row">
          <div className="col-12 ">
            <div className="table-responsive table-stripedd table-hoverr mt-2">
              {!RequestingMarketing && (
                <Fragment>
                  <InfiniteScroll
                    dataLength={marketing.length} //This is important field to render the next data
                    next={fetchMarketing}
                    hasMore={hasMore}
                    loader={
                      <div className="global-body-container h-100">
                        <div className="sk-three-bounce">
                          <div className="sk-child sk-bounce1"></div>
                          <div className="sk-child sk-bounce2"></div>
                          <div className="sk-child sk-bounce3"></div>
                        </div>
                      </div>
                    }
                    scrollThreshold={1.05}
                  >
                    {isMobile ? (
                      marketing &&
                      marketing
                        .filter((el) => {
                          if (searchInput === "") {
                            return el;
                          } else {
                            return el.campaignTitle
                              .toLowerCase()
                              .includes(searchInput.toLowerCase());
                          }
                        })
                        .map((campaign) => {
                          return (
                            <CampaignCard
                              campaignTitle={campaign.campaignTitle}
                              date={campaign?.createdAt
                                ?.toDate()
                                ?.toLocaleString("en-GB", {
                                  year: "numeric",
                                  month: "short",
                                  day: "numeric",
                                })}
                              campaignSource={campaign.campaignSource}
                              campaignType={campaign.campaignType}
                              leads={campaign.leads}
                              property={campaign.property}
                              template={campaign.template}
                              onEdit={() => {
                                navigate(
                                  `/user/marketing/campaign/reschedule/${campaign.id}`
                                );
                              }}
                              onClick={
                                () => {
                                  navigate(
                                    `/user/marketing/campaign/reschedule/${campaign.id}`
                                  );
                                }
                                //
                              }
                              onDelete={() => {
                                handleOpenDeleteDialog(campaign.id);
                              }}
                            />
                          );
                        })
                    ) : (
                      <table className="table table-borderless ">
                        <thead>
                          <tr>
                            <th scope="col" className="campaign-name ">
                              <span
                                className="campaign-name-padding"
                                style={{
                                  fontWeight: 500,
                                }}
                              >
                                Campaign Title
                              </span>
                            </th>
                            <th
                              scope="col"
                              style={{
                                fontWeight: 500,
                              }}
                            >
                              Campaign Source
                            </th>
                            <th
                              scope="col"
                              style={{
                                fontWeight: 500,
                              }}
                            >
                              Campaign Type
                            </th>
                            <th
                              scope="col"
                              style={{
                                fontWeight: 500,
                              }}
                            >
                              Total Clients
                            </th>

                            <th
                              scope="col"
                              style={{
                                fontWeight: 500,
                              }}
                            >
                              Actions
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {marketing &&
                            marketing
                              .filter((el) => {
                                if (searchInput === "") {
                                  return el;
                                } else {
                                  return el.campaignTitle
                                    .toLowerCase()
                                    .includes(searchInput.toLowerCase());
                                }
                              })
                              .map((campaign) => {
                                return (
                                  <Fragment>
                                    <tr
                                      onClick={() =>
                                        navigate(
                                          `/user/marketing/details/${campaign.id}`
                                        )
                                      }
                                    >
                                      <th
                                        className={`border-radius-left ${
                                          campaign?.status === "active"
                                            ? "active-border"
                                            : campaign?.status === "inactive"
                                            ? "inactive-border"
                                            : "pending-border"
                                        }`}
                                        scope="row"
                                      >
                                        {campaign?.campaignTitle}
                                        <br />
                                        <div className="alignment">
                                          <small className="add-on">
                                            Added on:
                                          </small>
                                          <small>
                                            {campaign?.createdAt
                                              ?.toDate()
                                              ?.toLocaleString("en-GB", {
                                                year: "numeric",
                                                month: "short",
                                                day: "numeric",
                                              })}
                                          </small>
                                        </div>
                                      </th>
                                      <td>{campaign?.campaignSource}</td>
                                      <td>{campaign?.campaignType}</td>
                                      <td>{campaign?.leads.length}</td>

                                      <td>
                                        {/* {campaign?.status !== "active" && ( */}
                                        <div className="edit-delete-svg">
                                          <span
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              handleOpenDeleteDialog(
                                                campaign?.id
                                              );
                                            }}
                                          >
                                            <DeleteOutlineRoundedIcon
                                              style={{ marginLeft: "5px" }}
                                              className="delete-icon"
                                            />
                                          </span>

                                          <span
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              navigate(
                                                `/user/marketing/campaign/reschedule/${campaign.id}`
                                              );
                                            }}
                                          >
                                            <ContentCopyRoundedIcon
                                              style={{ marginLeft: "5px" }}
                                              className="update-icon"
                                            />
                                          </span>
                                        </div>
                                        {/* )} */}
                                      </td>
                                    </tr>
                                  </Fragment>
                                );
                              })}
                        </tbody>
                      </table>
                    )}

                    {isMobile && marketing.length === 0 ? (
                      <div className="mobile-marketing-custom-nothing">
                        <NoDataFound />
                      </div>
                    ) : marketing.length === 0 ? (
                      <div className="marketing-custom-nothing">
                        <NoDataFound />
                      </div>
                    ) : (
                      ""
                    )}
                  </InfiniteScroll>
                </Fragment>
              )}
              {RequestingMarketing && <ContentLoader />}
            </div>
          </div>
        </div>
      </div>
      <ConfirmationModal
        title={"Delete Confirmation"}
        description={"Are you sure you want to delete this campaign?"}
        openDialog={DeleteDialog}
        handleCloseDialog={handleCloseDeleteDialog}
      />
      <ToastContainer />
    </Fragment>
  );
};

export default MarketingListing;
